import type { DocumentEntity } from '@api/types/document';

export type DocumentRowType = { label: string; color: string | null; locked: boolean };

/**
 * The types a document's row shows (DATA_FLOW §Document types): its one `documentType` when the read carries it,
 * otherwise the legacy `metaTypes`, by name. That covers a row without the key (an older API, or one merged from a
 * write's answer) and `null` beside the several types the old drawer could give. A platform type leaves `metaTypes`
 * empty, so only `documentType` shows it.
 */
export const documentRowTypes = ({
  documentType,
  metaTypes = [],
}: Pick<DocumentEntity, 'documentType' | 'metaTypes'>): DocumentRowType[] =>
  documentType
    ? [{ label: documentType.label, color: documentType.color, locked: documentType.locked }]
    : [...metaTypes]
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((type) => ({ label: type.title, color: type.color, locked: false }));
